/**
 *  AenaTerminalsFilter script file
 **/

import { mapGetters } from 'vuex'
import { GETTERS } from '@/store/constants'
import { getRefElement } from '@/utils/getRefElement'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaTerminalsFilter',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {
    airport: {
      type: Object,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeFilter: ''
    }
  },
  created () {
    this.activeFilter = this.activeFilterC.building
  },
  mounted () {
    if (this.activeFilter) {
      const filter = getRefElement(this.$refs[this.activeFilter])
      this.$refs.scrollbar.scrollTo(filter.offsetLeft, 0)
    }

    // NOTE: accessibility trick
    this.$refs.scrollContent.addEventListener('mouseover', () => {
      this.$refs.scrollContent.style.visibility = 'visible'
    }, false)
    this.$refs.scrollContent.addEventListener('mouseout', () => {
      this.$refs.scrollContent.style.visibility = 'hidden'
    }, false)
  },
  computed: {
    ...mapGetters({
      activeFilterC: GETTERS.GET_ACTIVE_FILTERS
    }),
    terminals () {
      return this.filters.filter(x => x.category === 'TERMINAL')
    },
    others () {
      return this.filters.filter(x => x.category !== 'TERMINAL')
    },
    associatedParking () {
      return this.activeFilterC.associatedParking || []
    }
  },
  methods: {
    setFilter (filter = {}) {
      this.activeFilter = filter.id
      this.$emit('onFilterChange', filter.id)
    },
    isAssociateActive (filter) {
      return this.activeFilter === filter || (this.activeFilterC.associatedParking || []).includes(filter)
    }
  }
}
